import { DateTime } from 'luxon'
import NotificationType from '@/models/enums/notification/NotificationType'

// Уведомления FAKT Support в колокольчике CRM (handoff 08-data-model.md, client_notification;
// экран p7). Чистые функции без Vue: их проверяет разовый скрипт, тестового контура в webcrm нет.

// Иконка и цвет по подтипу: reply и how_to_reg оранжевые, check_circle зелёная, schedule серая
// (11-acceptance.md). В webcrm нет Material Symbols - ближайшие из mdi.
const KINDS = {
    [NotificationType.SupportReplied]: { icon: 'mdi-reply', tone: 'orange' },
    [NotificationType.SupportTakenInWork]: { icon: 'mdi-account-check-outline', tone: 'orange' },
    [NotificationType.SupportSolvedRate]: { icon: 'mdi-check-circle-outline', tone: 'green' },
    [NotificationType.SupportClosedNoReply]: { icon: 'mdi-clock-outline', tone: 'grey' },
    [NotificationType.SupportCreated]: { icon: 'mdi-plus-circle-outline', tone: 'orange' },
}

export const RATE_HINT = 'Поставьте оценку - так мы поймём, помогли ли вам'

export function supportKind (type) {
    return KINDS[type] || KINDS[NotificationType.SupportReplied]
}

/** Оценка уже стоит: «Решено · 4815 · оцените помощь» превращается в «Решено · 4815». */
export function isRated (notification) {
    return notification.type === NotificationType.SupportSolvedRate && Number(notification.payload?.rating) > 0
}

export function supportTitle (notification) {
    return isRated(notification)
        ? notification.title.replace(/ · оцените помощь$/, '')
        : notification.title
}

/**
 * Вторая строка: «Иван · поддержка FAKT: текст». У «Решено» хвост дописывается здесь: просьба
 * оценить или «Спасибо за оценку ★ 4». У «Закрыто без ответа» автора нет, текст целиком с бэка.
 */
export function supportText (notification) {
    const author = notification.payload?.authorName
    const parts = []
    if (notification.description) parts.push(notification.description)
    if (notification.type === NotificationType.SupportSolvedRate) {
        parts.push(isRated(notification) ? `Спасибо за оценку ★ ${notification.payload.rating}` : RATE_HINT)
    }
    const text = parts.join('. ')
    // «Взяли в работу» приходит без текста: тогда только «Иван · поддержка FAKT», без двоеточия.
    if (!author) return text

    return text ? `${author} · поддержка FAKT: ${text}` : `${author} · поддержка FAKT`
}

/** Зона справа у непрочитанной строки: «Оценить» у неоценённого «Решено», иначе «Прочитано». */
export function supportAction (notification) {
    if (notification.isRead) return null
    if (notification.type === NotificationType.SupportSolvedRate && !isRated(notification)) return 'rate'

    return 'read'
}

/** Время в строке, как на p7: «2 мин», «1 ч», «вчера, 19:40», старше - «14 сент., 19:40». */
export function notificationTime (iso, now = DateTime.now()) {
    const at = DateTime.fromISO(iso).setZone(now.zone)
    if (!at.isValid) return ''

    const days = at.startOf('day').diff(now.startOf('day'), 'days').days
    if (days === 0) {
        const minutes = Math.max(0, Math.floor(now.diff(at, 'minutes').minutes))
        if (minutes < 1) return 'сейчас'
        if (minutes < 60) return `${minutes} мин`

        return `${Math.floor(minutes / 60)} ч`
    }
    if (days === -1) return `вчера, ${at.toFormat('HH:mm')}`

    return at.setLocale('ru').toFormat('d MMM, HH:mm')
}

/** Группы «СЕГОДНЯ», «ВЧЕРА» и дальше по датам; порядок внутри - как пришёл (свежие сверху). */
export function groupByDay (notifications, now = DateTime.now()) {
    const groups = []
    for (const notification of notifications) {
        const at = DateTime.fromISO(notification.createdAt).setZone(now.zone)
        const days = at.isValid ? at.startOf('day').diff(now.startOf('day'), 'days').days : 0
        const label = days === 0 ? 'Сегодня' : days === -1 ? 'Вчера' : at.setLocale('ru').toFormat('d MMMM')
        const last = groups[groups.length - 1]
        if (last && last.label === label) {
            last.items.push(notification)
        } else {
            groups.push({ label, items: [notification] })
        }
    }

    return groups
}

/**
 * Непрочитанные для бейджа: support - по серверному isRead, прочие типы CRM - по списку
 * просмотренных из localStorage (как было до поддержки).
 */
export function unseenCount (notifications, viewedIds) {
    return notifications.filter((item) => NotificationType.isSupport(item.type)
        ? !item.isRead
        : !viewedIds.includes(item.id)).length
}
